import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMaintenance = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 604,
	height: 263,
	viewBox: "0 0 604 263",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_24470_77065)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 604,
					height: 263,
					rx: 24,
					fill: "url(#paint0_linear_24470_77065)"
				}),
				/* @__PURE__ */ _jsxs("g", {
					filter: "url(#filter0_d_24470_77065)",
					children: [
						/* @__PURE__ */ _jsx("rect", {
							x: 71,
							y: 87,
							width: 292,
							height: 382.906,
							rx: 13.5305,
							fill: "#f6f6f7"
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 45.1017,
							height: 9.57465,
							rx: 4.78732,
							transform: "matrix(-1 0 0 1 213.789 134.575)",
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 76.1897,
							height: 9.57465,
							rx: 4.78732,
							transform: "matrix(-1 0 0 1 165.199 134.575)",
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 89.0117,
							y: 153.723,
							width: 47.33,
							height: 9.57465,
							rx: 4.78732,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 141.637,
							y: 153.723,
							width: 72.1628,
							height: 9.57465,
							rx: 4.78732,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 79.6797,
							height: 9.57465,
							rx: 4.78732,
							transform: "matrix(-1 0 0 1 168.68 172.873)",
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 114.258,
							height: 67.0225,
							rx: 7.51696,
							transform: "matrix(-1 0 0 1 343.078 125)",
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 218.289,
							y: 213.287,
							width: 45.1017,
							height: 10.2889,
							rx: 5.14447,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 266.879,
							y: 213.287,
							width: 76.1897,
							height: 10.2889,
							rx: 5.14447,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 47.33,
							height: 10.2889,
							rx: 5.14447,
							transform: "matrix(-1 0 0 1 343.066 233.865)",
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 72.1628,
							height: 10.2889,
							rx: 5.14447,
							transform: "matrix(-1 0 0 1 290.441 233.865)",
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 263.398,
							y: 254.444,
							width: 79.6797,
							height: 10.2889,
							rx: 5.14447,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 89,
							y: 202.998,
							width: 114.258,
							height: 72.0247,
							rx: 7.51696,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 84.5273,
							y: 99.0271,
							width: 15.0339,
							height: 15.0339,
							rx: 7.51696,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 107.078,
							y: 103.537,
							width: 22.5509,
							height: 6.01356,
							rx: 3.00678,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 137.145,
							y: 103.537,
							width: 22.5509,
							height: 6.01356,
							rx: 3.00678,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 167.215,
							y: 103.537,
							width: 22.5509,
							height: 6.01356,
							rx: 3.00678,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 197.281,
							y: 103.537,
							width: 22.5509,
							height: 6.01356,
							rx: 3.00678,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 307.035,
							y: 99.0264,
							width: 40.5916,
							height: 15.0339,
							rx: 7.51696,
							fill: "#2A6DF4"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("g", {
					filter: "url(#filter1_d_24470_77065)",
					children: [
						/* @__PURE__ */ _jsx("rect", {
							x: 144,
							y: 39,
							width: 292,
							height: 382.906,
							rx: 13.5305,
							fill: "#f6f6f7"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M166.547 141.231L225.074 96.1017C227.326 94.3652 230.486 94.4436 232.649 96.2895L281.335 137.835C283.617 139.782 286.985 139.75 289.229 137.76L320.962 109.619C323.324 107.525 326.903 107.613 329.159 109.822L356.89 136.975C359.282 139.318 363.127 139.255 365.442 136.837L411.6 88.6121",
							stroke: "#9A9A9A",
							strokeOpacity: .13,
							strokeWidth: 9.02035,
							strokeLinecap: "round"
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 45.1017,
							height: 9.02035,
							rx: 4.51017,
							transform: "matrix(-1 0 0 1 286.809 181.822)",
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 76.1897,
							height: 9.02035,
							rx: 4.51017,
							transform: "matrix(-1 0 0 1 238.219 181.822)",
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 162.031,
							y: 199.861,
							width: 47.33,
							height: 9.02035,
							rx: 4.51017,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 214.656,
							y: 199.861,
							width: 72.1628,
							height: 9.02035,
							rx: 4.51017,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 79.6797,
							height: 9.02035,
							rx: 4.51017,
							transform: "matrix(-1 0 0 1 241.699 217.903)",
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 114.258,
							height: 63.1424,
							rx: 7.51696,
							transform: "matrix(-1 0 0 1 416.098 172.801)",
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 291.332,
							y: 259.999,
							width: 45.1017,
							height: 9.02035,
							rx: 4.51017,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 339.922,
							y: 259.999,
							width: 76.1897,
							height: 9.02035,
							rx: 4.51017,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 162.043,
							y: 250.979,
							width: 114.258,
							height: 63.1424,
							rx: 7.51696,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 157.527,
							y: 51.0271,
							width: 15.0339,
							height: 15.0339,
							rx: 7.51696,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 180.078,
							y: 55.5374,
							width: 22.5509,
							height: 6.01356,
							rx: 3.00678,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 210.145,
							y: 55.5374,
							width: 22.5509,
							height: 6.01356,
							rx: 3.00678,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 240.215,
							y: 55.5374,
							width: 22.5509,
							height: 6.01356,
							rx: 3.00678,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 270.281,
							y: 55.5374,
							width: 22.5509,
							height: 6.01356,
							rx: 3.00678,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 380.035,
							y: 51.0264,
							width: 40.5916,
							height: 15.0339,
							rx: 7.51696,
							fill: "#2A6DF4"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("g", {
					filter: "url(#filter2_d_24470_77065)",
					children: [
						/* @__PURE__ */ _jsx("rect", {
							x: 241,
							y: 96,
							width: 292,
							height: 382.906,
							rx: 13.5305,
							fill: "#f6f6f7"
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 46.9813,
							height: 9.02035,
							rx: 4.51017,
							transform: "matrix(-1 0 0 1 384.988 237.822)",
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 79.3648,
							height: 9.02035,
							rx: 4.51017,
							transform: "matrix(-1 0 0 1 334.371 237.822)",
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 255.012,
							y: 255.861,
							width: 49.3024,
							height: 9.02035,
							rx: 4.51017,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 309.832,
							y: 255.861,
							width: 75.1701,
							height: 9.02035,
							rx: 4.51017,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 119,
							height: 63,
							rx: 7.51696,
							transform: "matrix(-1 0 0 1 518 229)",
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 263,
							height: 75,
							rx: 7.51696,
							transform: "matrix(-1 0 0 1 518 139)",
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 254.527,
							y: 108.027,
							width: 15.0339,
							height: 15.0339,
							rx: 7.51696,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 277.078,
							y: 112.537,
							width: 22.5509,
							height: 6.01356,
							rx: 3.00678,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 307.145,
							y: 112.537,
							width: 22.5509,
							height: 6.01356,
							rx: 3.00678,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 337.215,
							y: 112.537,
							width: 22.5509,
							height: 6.01356,
							rx: 3.00678,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 367.281,
							y: 112.537,
							width: 22.5509,
							height: 6.01356,
							rx: 3.00678,
							fill: "#9A9A9A",
							fillOpacity: .13
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 477.035,
							y: 108.026,
							width: 40.5916,
							height: 15.0339,
							rx: 7.51696,
							fill: "#2A6DF4"
						})
					]
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 603,
			height: 262,
			rx: 23.5,
			stroke: "white",
			strokeOpacity: .05
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_24470_77065",
				x: 9.84114,
				y: 60.7891,
				width: 414.318,
				height: 505.223,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 11.6493,
						operator: "dilate",
						in: "SourceAlpha",
						result: "effect1_dropShadow_24470_77065"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 34.9479 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 24.7548 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_24470_77065"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_24470_77065",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_24470_77065",
				x: 82.8411,
				y: 12.7891,
				width: 414.318,
				height: 505.223,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 11.6493,
						operator: "dilate",
						in: "SourceAlpha",
						result: "effect1_dropShadow_24470_77065"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 34.9479 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 24.7548 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_24470_77065"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_24470_77065",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_d_24470_77065",
				x: 179.841,
				y: 69.7891,
				width: 414.318,
				height: 505.223,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 11.6493,
						operator: "dilate",
						in: "SourceAlpha",
						result: "effect1_dropShadow_24470_77065"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 34.9479 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 24.7548 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_24470_77065"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_24470_77065",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_24470_77065",
				x1: 302,
				y1: 0,
				x2: 302,
				y2: 263,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#f6f6f7" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#f9fafb"
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_24470_77065",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 604,
					height: 263,
					rx: 24,
					fill: "white"
				})
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgMaintenance);
export { ForwardRef as ReactComponent };
